<template>
    <el-input class="filterItem-value"
        v-if="showInput"
        v-model="filterItem.value[0]"
        clearable
    />
</template>

<style>
    
</style>

<script>
    import baseFilter from "../../BaseFilter"

    export default {
        name:"MultTextFieldFilter",
        mixins:[baseFilter]
    }
</script>